
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("login/app", function(){ return i("login/app.ts");});
d("login/config/environment", function(){ return i("login/config/environment.js");});
d("login/initializers/logging", function(){ return i("login/initializers/logging.ts");});
d("login/models/logon-params", function(){ return i("login/models/logon-params.ts");});
d("login/models/version", function(){ return i("login/models/version.ts");});
d("login/router", function(){ return i("login/router.ts");});
d("login/services/page-title", function(){ return i("login/services/page-title.js");});
d("login/services/flash-messages-service", function(){ return i("login/services/flash-messages-service.js");});
d("login/initializers/app-version", function(){ return i("login/initializers/app-version.js");});
d("login/services/intl", function(){ return i("login/services/intl.js");});
d("login/templates/application", function(){ return i("login/templates/application.ts");});
d("login/controllers/application", function(){ return i("login/controllers/application.ts");});
d("login/routes/application", function(){ return i("login/routes/application.ts");});
d("login/templates/register-user", function(){ return i("login/templates/register-user.ts");});
d("login/routes/register-user", function(){ return i("login/routes/register-user.ts");});
d("login/templates/application-loading", function(){ return i("login/templates/application-loading.ts");});
d("login/templates/change-password", function(){ return i("login/templates/change-password.ts");});
d("login/templates/disconnected", function(){ return i("login/templates/disconnected.ts");});
d("login/templates/expired", function(){ return i("login/templates/expired.ts");});
d("login/templates/forgot-password", function(){ return i("login/templates/forgot-password.ts");});
d("login/templates/index", function(){ return i("login/templates/index.ts");});
d("login/templates/set-password", function(){ return i("login/templates/set-password.ts");});





if (!runningTests) {
  i("../app").default.create({"name":"ProductionCenterLogin","version":"15.87.0-101 (2026-03-25 18:49:45)","shortVersion":"15.87.0-101","pageTitle":{"replace":true}});
}

